import { useSyncExternalStore } from 'react';

// 상품/카테고리/블로그 데이터는 mocks 배열(참조 고정, 내용만 mutate)로 관리되기 때문에,
// 데이터가 새로 채워져도 React가 자동으로 다시 그리지 않습니다.
// 이 스토어는 "데이터가 갱신됐다"는 신호(version)를 컴포넌트에 보내서
// 필요한 곳만 다시 그리게 해주는 아주 얇은 pub-sub입니다.
// 상단바(Navbar) 등은 이 신호를 기다리지 않고 항상 즉시 렌더링됩니다 —
// 데이터가 늦게 와도 카테고리 목록만 나중에 채워질 뿐, 버튼 자체는 처음부터 눌립니다.

let version = 0;
let ready = false;
const listeners = new Set<() => void>();

export function markCatalogUpdated() {
  version += 1;
  ready = true;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useCatalogVersion(): number {
  return useSyncExternalStore(subscribe, () => version, () => version);
}

export function useCatalogReady(): boolean {
  return useSyncExternalStore(subscribe, () => ready, () => ready);
}
